import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { ACTION_TRIGGER } from '../../../../participants-pane/constants';
import participantsPaneTheme from '../../../components/themes/participantsPaneTheme.json';
import { isMobileBrowser } from '../../../environment/utils';
const useStyles = makeStyles()(theme => {
    return {
        container: {
            alignItems: 'center',
            color: 'rgba(255, 255, 255, 0.75)',
            display: 'flex',
            fontFamily: 'Lato Bold',
            fontWeight: 'normal',
            fontSize: '15px',
            lineHeight: '20px',
            margin: `0 -${participantsPaneTheme.panePadding}px`,
            padding: '6px 8px 6px 24px',
            width: '100%',
            position: 'relative',
            '&:hover, &:focus-within': {
                backgroundColor: 'transparent',
                '& .actions': {
                    display: 'flex',
                    position: 'absolute',
                    right: '0',
                    top: 'auto',
                    backgroundColor: 'rgba(33, 33, 33, 1)'
                },
            },
            '&.is-mobile': {
                fontSize: '16px',
                margin: 0,
                padding: 0,
                '& .actions': {
                    display: 'flex',
                    position: 'absolute',
                    right: '0',
                    top: 'auto',
                    backgroundColor: 'rgba(28, 28, 28, 1)',
                },
            }
        },
        highlighted: {
            backgroundColor: theme.palette.ui02,
            '& .actions': {
                display: 'flex',
                position: 'relative',
                top: 'auto',
                backgroundColor: theme.palette.ui02
            }
        },
        detailsContainer: {
            display: 'flex',
            alignItems: 'center',
            flex: 1,
            height: '100%',
            overflow: 'hidden',
            position: 'relative',
            '&.is-mobile': {
                padding: '10px 16px 9.5px 0',
                borderBottom: '0.5px solid rgba(255, 255, 255, 0.08)',
            }
        },
        name: {
            display: 'flex',
            flex: 1,
            marginRight: '11px',
            overflow: 'hidden',
            flexDirection: 'column',
            justifyContent: 'flex-start'
        },
        indicators: {
            display: 'flex',
            justifyContent: 'flex-end',
            paddingRight: '3px',
            '& > *': {
                alignItems: 'center',
                display: 'flex',
                justifyContent: 'center'
            },
            '& > *:not(:last-child)': {
                marginRight: '12px',
            },
            '& .jitsi-icon': {
                padding: '2px',
            },
            '&.is-mobile': {
                paddingRight: 0,
                '& > *:not(:last-child)': {
                    marginRight: '16px',
                },
                '& .jitsi-icon': {
                    padding: 0,
                },
            },
        },
        indicatorsHidden: {
            display: 'none'
        },
        actionsContainer: {
            position: 'absolute',
            top: '-1000px',
            backgroundColor: theme.palette.ui02,
            '&.is-mobile': {
                backgroundColor: 'rgba(28, 28, 28, 1)',
                marginRight: '8px',
            }
        },
        actionsGradient: {
            background: 'linear-gradient(270deg, #212121 0%, rgba(33, 33, 33, 0) 33.5%)',
            width: '32px',
            left: '-32px',
            height: '35px',
            position: 'absolute',
        },
        actionsPermanent: {
            display: 'flex',
            backgroundColor: theme.palette.ui01
        },
        actionsVisible: {
            display: 'flex',
            backgroundColor: theme.palette.ui02
        }
    };
});
const ListItem = ({ actions, className, defaultName, icon, iconClassName, id, hideActions = false, indicators, isHighlighted, onClick, onLongPress, onMouseLeave, testId, textChildren, trigger }) => {
    const { classes, cx } = useStyles();
    const isMobile = isMobileBrowser();
    let timeoutHandler;
    /**
     * Set calling long press handler after x milliseconds.
     *
     * @param {TouchEvent} e - Touch start event.
     * @returns {void}
     */
    function _onTouchStart(e) {
        const target = e.touches[0].target;
        timeoutHandler = window.setTimeout(() => onLongPress?.(target), 600);
    }
    /**
     * Cancel calling on long press after x milliseconds if the number of milliseconds is not reached
     * before a touch move(drag), or just clears the timeout.
     *
     * @returns {void}
     */
    function _onTouchMove() {
        clearTimeout(timeoutHandler);
    }
    /**
     * Cancel calling on long press after x milliseconds if the number of milliseconds is not reached yet,
     * or just clears the timeout.
     *
     * @returns {void}
     */
    function _onTouchEnd() {
        clearTimeout(timeoutHandler);
    }
    return (React.createElement("div", { "aria-label": defaultName, className: cx('list-item-container', classes.container, isHighlighted && classes.highlighted, className, isMobileBrowser() && 'is-mobile'), "data-testid": testId, id: id, onClick: onClick, role: 'listitem', ...(isMobile
            ? {
                onTouchEnd: _onTouchEnd,
                onTouchMove: _onTouchMove,
                onTouchStart: _onTouchStart
            }
            : {
                onMouseLeave
            }) },
        React.createElement("div", { className: iconClassName ?? '' },
            " ",
            icon,
            " "),
        React.createElement("div", { className: cx(classes.detailsContainer, 'list-item-details-container', isMobile && 'is-mobile') },
            React.createElement("div", { className: classes.name }, textChildren),
            indicators && (React.createElement("div", { className: cx('indicators', classes.indicators, (isHighlighted || trigger === ACTION_TRIGGER.PERMANENT) && classes.indicatorsHidden, isMobile && 'is-mobile') }, indicators)),
            !hideActions && (React.createElement("div", { className: cx('actions', classes.actionsContainer, isMobile && 'is-mobile', trigger === ACTION_TRIGGER.PERMANENT && classes.actionsPermanent, isHighlighted && classes.actionsVisible) },
                !isMobile && React.createElement("div", { className: classes.actionsGradient }),
                actions)))));
};
export default ListItem;
